import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BaseModule } from '../../base/base.module';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { DialogModule } from 'primeng/dialog';
import { ProductInfoComponent } from './product-info.component';

@NgModule({
  declarations: [ProductInfoComponent],
  imports: [CommonModule, BaseModule, ButtonModule, CardModule, DialogModule],
  providers: [],
})
export class ProductInfoModule {}
